<p-overlayPanel #op>
    <div
        *ngFor="let item of rowsPerPageOptions"
        class="custom-dropdown-item"
        [ngClass]="{ 'selected': item === rowsPerPage }"
        (click)="onSelectRowsPerPage(item)">
        <button 
            pButton 
            type="button" 
            icon="pi pi-minus" 
            (click)="onRemoveItem($event, item)">
        </button>
        <span>{{ item }}</span>
    </div>
    <div class="custom-dropdown-item">
        <button 
            pButton 
            type="button" 
            icon="pi pi-plus" 
            (click)="onAddRowsPerPage()">
        </button>
        <input type="number" [(ngModel)]="customRowsPerPage" placeholder="{{ 'Common.Table.CustomRowsPerPage' | translate }}"
            class="p-inputtext p-component"/>
    </div>
</p-overlayPanel>
<!-- 觸發下拉選單的按鈕 -->
<button 
  pButton
  type="button"
  [disabled]="disabled"
  class="custom-dropdown-button"
  [label]="(rowsPerPage || '') + ''" 
  icon="pi pi-chevron-down" 
  iconPos="right"
  (click)="showOverlayPanel($event)">
</button>
